
/// Para entender como usar el componente
/// https://github.com/portinos/TowerTravel-Sports/wiki/SocialMedia.jsx


/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useTranslation } from "react-i18next";

import {
  FacebookIcon,
  InstagramIcon,
  YoutubeIcon,
  TwitterIcon,
  LinkedinIcon,
} from "./index";

const SocialMedia = ({ fill, background, fb, ig, lin, tt, yt }) => {
  const { t } = useTranslation();

  const bgColor = { backgroundColor: background };

  return (
    <div className="socials">
      {/* Facebook = fb */}
      {fb && (
        <a
          href={t("links.facebook")}
          target="_blank"
          rel="noopener noreferrer"
          className="icon"
          style={bgColor}
        >
          <FacebookIcon fill={fill} />
        </a>
      )}

      {/* Instagram = ig */}
      {ig && (
        <a
          href={t("links.instagram")}
          target="_blank"
          rel="noopener noreferrer"
          className="icon"
          style={bgColor}
        >
          <InstagramIcon fill={fill} />
        </a>
      )}

      {/* Linkedin = lin */}

      {lin && (
        <a
          href={t("links.linkedin")}
          target="_blank"
          rel="noopener noreferrer"
          className="icon"
          style={bgColor}
        >
          <LinkedinIcon fill={fill} />
        </a>
      )}

      {/* Twitter = tt */}
      {tt && (
        <a
          href={t("links.twitter")}
          target="_blank"
          rel="noopener noreferrer"
          className="icon"
          style={bgColor}
        >
          <TwitterIcon fill={fill} />
        </a>
      )}

      {/* Youtube = yt */}
      {yt && (
        <a
          href={t("links.youtube")}
          target="_blank"
          rel="noopener noreferrer"
          className="icon"
          style={bgColor}
        >
          <YoutubeIcon fill={fill} />
        </a>
      )}
    </div>
  );
};

export default SocialMedia;
